export const CHECKOUT_URL = 'https://entrenador-de-futbol.impultienda.ar/checkout'

/* Todos los botones e imágenes llevan a la sección de compra */
export const OFFER_ANCHOR = '#oferta'

export const SUPPORT_EMAIL = 'soportescmdigital@gmail.com'

export const PACK_IMAGE =
  'https://cdn.magicpatterns.com/uploads/bCigq2FuAeLKCeUPKskvEq/Pack_completo_de_entrenador_de_futbol.png'

export const PRODUCT_NAME = 'MEGA PACK ENTRENADOR DE FÚTBOL – DE CERO A PROFESIONAL'

export const PRICE = '$19.990'

export const BONUS_TOTAL = '$39.950'

/* 1. PROBLEMA */
export const problems = [
  {
    title: 'INFORMACIÓN DISPERSA',
    desc: 'Guardas videos de ejercicios, tácticas, formaciones y entrenamientos, pero cada uno explica algo diferente y no sabes cómo organizar una sesión completa.',
  },
  {
    title: 'NO SABES QUÉ ENSEÑAR PRIMERO',
    desc: 'Conducción, pases, definición, coordinación, defensa, táctica, preparación física... hay tantos aspectos que no sabes cómo ordenarlos según la edad de tus jugadores.',
  },
  {
    title: 'TE FALTA UNA PLANIFICACIÓN',
    desc: 'Quieres dirigir entrenamientos de calidad, pero necesitas una guía que te indique qué ejercicios realizar, cómo organizar las sesiones y cómo evaluar los avances.',
  },
  {
    title: 'SIGUES IMPROVISANDO',
    desc: 'Quieres preparar mejores entrenamientos, pero terminás repitiendo ejercicios, buscando ideas a último momento y sin tener una planificación clara para tu equipo.',
  },
]

/* 2. SOLUCIÓN — 6 TOMOS */
export const tomos = [
  {
    title: 'FUNDAMENTOS DEL ENTRENADOR DE FÚTBOL',
    desc: 'Comprende las funciones del entrenador, los principios de enseñanza, la comunicación con jugadores, la organización de grupos, los objetivos de formación y las bases para dirigir entrenamientos.',
  },
  {
    title: 'ENTRENAMIENTOS DE FÚTBOL INFANTIL – 5 A 8 AÑOS',
    desc: 'Aprende a preparar entrenamientos para los más pequeños mediante juegos, coordinación, conducción, pases, actividades recreativas y ejercicios adaptados a cada etapa de aprendizaje.',
  },
  {
    title: 'ENTRENAMIENTOS PREJUVENILES – 9 A 12 AÑOS',
    desc: 'Descubre cómo enseñar controles, pases, regates, remates, movimientos colectivos, toma de decisiones y ejercicios progresivos para desarrollar habilidades futbolísticas.',
  },
  {
    title: 'ENTRENAMIENTOS PARA JUVENILES Y ADULTOS',
    desc: 'Aprende a organizar sesiones más avanzadas, trabajar técnica bajo presión, defensa, ataque, transiciones, preparación de partidos y entrenamientos adaptados al nivel del equipo.',
  },
  {
    title: 'TÁCTICAS, FORMACIONES Y ESTRATEGIAS DE FÚTBOL',
    desc: 'Comprende sistemas de juego, formaciones, movimientos ofensivos, organización defensiva, presión, coberturas, transiciones y jugadas preparadas para aplicar en tus entrenamientos.',
  },
  {
    title: 'PLANIFICACIÓN DE ENTRENAMIENTOS Y TEMPORADAS',
    desc: 'Aprende a organizar sesiones diarias, planes semanales, objetivos mensuales, pretemporadas, calendarios de trabajo, seguimiento de jugadores y planificación completa de una temporada.',
  },
]

/* 3. BONOS */
export const bonuses = [
  {
    title: '100 EJERCICIOS DE FÚTBOL',
    desc: 'Una colección de 100 ejercicios organizados por habilidades: conducción, control, pases, regates, remates, defensa, táctica, posesión, juegos reducidos y coordinación.',
    value: '$7.990',
  },
  {
    title: '50 SESIONES DE ENTRENAMIENTO LISTAS PARA APLICAR',
    desc: '50 entrenamientos organizados por edades y objetivos, con actividades, tiempos y secuencias prácticas para preparar tus clases sin comenzar desde cero.',
    value: '$5.990',
  },
  {
    title: 'MANUAL DE ENTRENAMIENTO PARA ARQUEROS',
    desc: 'Una guía práctica para trabajar posicionamiento, recepciones, reflejos, desplazamientos, salidas, juego con los pies, comunicación y sesiones específicas para arqueros.',
    value: '$6.990',
  },
  {
    title: '30 DIAGRAMAS TÁCTICOS Y JUGADAS PREPARADAS',
    desc: '30 jugadas y esquemas tácticos explicados para comprender movimientos ofensivos, defensivos, formaciones, transiciones, córners, tiros libres y saques laterales.',
    value: '$8.990',
  },
  {
    title: 'PLANILLAS PARA EVALUAR JUGADORES Y PLANIFICAR ENTRENAMIENTOS',
    desc: '20 modelos de planillas para registrar asistencia, evaluar habilidades técnicas y tácticas, controlar entrenamientos, analizar partidos y realizar seguimientos individuales.',
    value: '$9.990',
  },
]

/* 4. BENEFICIOS */
export const benefits = [
  {
    title: 'MENOS IMPROVISACIÓN',
    desc: 'Deja de buscar ejercicios a último momento y sigue una ruta organizada desde los fundamentos hasta la planificación de entrenamientos y temporadas.',
  },
  {
    title: 'MÁS RECURSOS PRÁCTICOS',
    desc: 'Accede a ejercicios, sesiones, actividades por edades, tácticas, formaciones, entrenamientos para arqueros y herramientas para evaluar jugadores.',
  },
  {
    title: 'COMPRENDE CÓMO ENTRENAR',
    desc: 'Empieza a preparar una sesión sabiendo qué objetivo trabajar, qué ejercicios utilizar, cómo organizar los tiempos y qué aspectos observar en tus jugadores.',
  },
  {
    title: 'UNA NUEVA HABILIDAD',
    desc: 'Desarrolla conocimientos que pueden ser el primer paso para colaborar en una escuelita, organizar entrenamientos y ampliar tus posibilidades dentro del fútbol formativo.',
  },
]

/* 5. TESTIMONIOS */
export const testimonials = [
  {
    quote:
      'Me ofrecieron hacerme cargo de la categoría 2014 del club del barrio y no tenía idea de cómo armar una práctica. Con el Tomo 1 y las 50 sesiones listas aprendí a dividir el entrenamiento en entrada en calor, parte principal y juego final. Ahora llego a la cancha con todo planificado y los chicos se enganchan mucho más.',
    author: 'Diego Fernández',
    role: 'Entrenador de categoría infantil, 38 años',
    location: 'Córdoba, Argentina',
  },
  {
    quote:
      'Mi hijo juega en una escuelita y empecé ayudando al profe con los más chiquitos. El tomo de fútbol infantil de 5 a 8 años me mostró cómo enseñar conducción y pases con juegos, sin aburrirlos. Hoy coordino un grupo de 15 nenes y nenas y cada sábado tengo actividades nuevas.',
    author: 'Romina Gutiérrez',
    role: 'Colaboradora en escuelita de fútbol, 34 años',
    location: 'Rosario, Argentina',
  },
  {
    quote:
      'Jugué muchos años en el ascenso, pero entrenar es otra cosa. El tomo de tácticas y los 30 diagramas me ayudaron a explicar la presión, las coberturas y las jugadas preparadas de forma clara. Mi equipo de juveniles ya trabaja los córners y tiros libres con otra organización.',
    author: 'Martín Acosta',
    role: 'Exjugador y DT de juveniles, 41 años',
    location: 'Mendoza, Argentina',
  },
  {
    quote:
      'Estoy estudiando para ser entrenador y necesitaba material práctico para complementar. Los 100 ejercicios organizados por habilidad son oro: los uso para preparar mis prácticas profesionales y ya tengo un banco de ejercicios para cada objetivo de la sesión.',
    author: 'Tomás Herrera',
    role: 'Estudiante de entrenador de fútbol, 24 años',
    location: 'La Plata, Argentina',
  },
  {
    quote:
      'Dirijo un equipo femenino de 12 a 14 años y siempre anotaba todo en cuadernos sueltos. Con las planillas de evaluación y el tomo de planificación ordené la temporada completa: asistencia, avances técnicos y objetivos mensuales. Las familias notan el cambio y las chicas también.',
    author: 'Valeria Moreno',
    role: 'Entrenadora de fútbol femenino, 29 años',
    location: 'San Miguel de Tucumán, Argentina',
  },
]

/* 6. FAQ */
export const faqs = [
  { q: '¿Es físico o digital?', a: 'Es un producto 100% digital.' },
  {
    q: '¿Necesito conocimientos previos?',
    a: 'No. El material comienza con los fundamentos y avanza progresivamente hacia entrenamientos, tácticas y planificación.',
  },
  {
    q: '¿Qué voy a aprender?',
    a: 'Aprenderás fundamentos del entrenador, ejercicios por edades, técnicas de fútbol, tácticas, formaciones, planificación de sesiones y organización de temporadas.',
  },
  {
    q: '¿Incluye ejercicios?',
    a: 'Sí. Incluye 100 ejercicios de fútbol y 50 sesiones de entrenamiento, además de los ejercicios y actividades desarrollados en los tomos.',
  },
  {
    q: '¿Los bonos tienen costo adicional?',
    a: 'No. Los 5 bonos están incluidos con la compra del Mega Pack.',
  },
  {
    q: '¿Es un pago único?',
    a: 'Sí. Realizas un único pago para acceder al material digital incluido.',
  },
  {
    q: '¿Obtengo acceso inmediatamente?',
    a: 'Sí. El acceso al material digital se entrega después de confirmarse el pago.',
  },
  {
    q: '¿Esto me habilita profesionalmente?',
    a: 'No. Es material educativo y no reemplaza títulos, licencias, certificaciones o requisitos que puedan exigirse para trabajar como entrenador.',
  },
  {
    q: '¿Puedo aprender a mi ritmo?',
    a: 'Sí. Puedes estudiar los tomos y consultar los recursos según tu disponibilidad.',
  },
  {
    q: '¿Dónde solicito soporte?',
    a: 'Puedes escribir a soportescmdigital@gmail.com.',
  },
]

/* POP-UP DE COMPRAS RECIENTES — ARGENTINA */
export const recentBuyers = [
  { name: 'Sebastián Gómez', city: 'Córdoba', minutes: 2 },
  { name: 'Lucas Romero', city: 'Rosario', minutes: 4 },
  { name: 'Valentina Díaz', city: 'Buenos Aires', minutes: 7 },
  { name: 'Julián Pereyra', city: 'Mendoza', minutes: 11 },
  { name: 'Matías Medina', city: 'La Plata', minutes: 15 },
  { name: 'Agustín Torres', city: 'Mar del Plata', minutes: 19 },
  { name: 'Carla Acosta', city: 'Salta', minutes: 24 },
  { name: 'Ezequiel Molina', city: 'San Miguel de Tucumán', minutes: 29 },
  { name: 'Nahuel Ríos', city: 'Neuquén', minutes: 33 },
  { name: 'Gonzalo Herrera', city: 'Santa Fe', minutes: 40 },
]
